import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/** Multi-select assignee picker used when creating and editing issues. */
export const AssigneePicker = ({ users, value, onChange, testId = "issue-assignee-select" }) => {
  const selected = value || [];
  const label =
    selected.length === 0
      ? "Unassigned"
      : selected.length === 1
        ? users.find((u) => u.id === selected[0])?.full_name ||
          users.find((u) => u.id === selected[0])?.email ||
          "1 person"
        : `${selected.length} people`;

  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testId}
          className="flex h-9 w-full items-center justify-between gap-1 rounded-md border border-slate-200 bg-[#EEF2F8] px-3 text-xs text-slate-700 hover:bg-slate-100"
        >
          <span className="truncate">{label}</span>
          <ChevronDown size={13} className="shrink-0 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="max-h-64 w-56 overflow-y-auto border-slate-200 bg-white text-slate-800"
      >
        {users.map((user) => (
          <DropdownMenuCheckboxItem
            key={user.id}
            data-testid={`assignee-option-${user.id}`}
            checked={selected.includes(user.id)}
            onCheckedChange={() => toggle(user.id)}
            onSelect={(event) => event.preventDefault()}
            className="text-xs"
          >
            {user.full_name || user.email}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
